import React, { useEffect } from "react";
import { FormCustomers } from "../components/FormCustomers";
import usePermission from "../../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import { FeatureStatic } from "../../../@types/statics/feature.static";
import styles from "./styles.module.scss";

export const CreateCustomers: React.FC = () => {
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.clients.id);
  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);
  return (
    <>
      <div className={styles.createCustomers}>
        <FormCustomers pageType="create" />
      </div>
    </>
  );
};
